import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Printer, ArrowLeft } from "lucide-react";

const StockLabel = ({ item, width }) => {
  const small = width === 58;
  const url = `${window.location.origin}/stock/scan/${item.id}`;
  return (
    <div className="thermal-label bg-white text-black font-mono mx-auto" style={{ width: `${width}mm`, padding: small ? "2mm" : "3mm" }} data-testid={`stock-label-${item.sku}`}>
      <div className="flex items-center justify-between border-b-2 border-black pb-1">
        <div>
          <div className="text-[9px] uppercase tracking-widest">Rozfa Printing • Stock</div>
          <div className={`${small ? "text-base" : "text-xl"} font-black leading-tight`}>{item.sku}</div>
        </div>
        <QRCodeSVG value={url} size={small ? 64 : 84} level="H" includeMargin data-testid={`stock-label-qr-${item.sku}`} />
      </div>
      <div className="py-1 text-[11px] leading-snug">
        <div className="font-bold text-[13px]">{item.name}</div>
        <div className="flex justify-between"><span>Category</span><span className="font-bold">{item.category}</span></div>
        <div className="flex justify-between"><span>Unit</span><span className="font-bold">{item.unit}</span></div>
        {item.location && <div className="flex justify-between"><span>Location</span><span className="font-bold">{item.location}</span></div>}
        {item.supplier && <div className="flex justify-between"><span>Supplier</span><span className="font-bold truncate ml-2">{item.supplier}</span></div>}
      </div>
      <div className="text-[9px] text-center border-t border-dashed border-black pt-1">Scan to record Stock In / Out</div>
    </div>
  );
};

export default function StockLabels() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [items, setItems] = useState(null);
  const [width, setWidth] = useState(Number(localStorage.getItem("labelWidth")) || 80);
  useEffect(() => {
    const ids = (params.get("ids") || "").split(",").filter(Boolean);
    (ids.length ? api.post("/stock/labels", ids) : api.get("/stock")).then((r) => setItems(r.data));
  }, [params]);
  const setW = (w) => { setWidth(w); localStorage.setItem("labelWidth", String(w)); };
  if (!items) return <div className="p-8 text-muted-foreground">Loading...</div>;
  return (
    <div className="min-h-screen bg-neutral-200 print:bg-white" data-testid="stock-labels-page">
      <style>{`@media print { @page { size: ${width}mm auto; margin: 0; } body { background: white; } .thermal-label { page-break-after: always; } .thermal-label:last-child { page-break-after: auto; } }`}</style>
      <div className="print:hidden sticky top-0 z-10 flex flex-wrap items-center gap-2 p-3 border-b bg-white">
        <Button variant="outline" size="sm" onClick={() => nav(-1)} data-testid="stock-label-back"><ArrowLeft className="w-4 h-4 mr-1" /> Back</Button>
        <div className="font-semibold text-sm">{items.length} stock label(s)</div>
        <div className="flex items-center gap-1 ml-2 text-xs"><span className="text-muted-foreground">Paper:</span>{[80, 58].map((w) => <Button key={w} size="sm" variant={width === w ? "default" : "outline"} className="h-7" onClick={() => setW(w)}>{w}mm</Button>)}</div>
        <Button size="sm" className="ml-auto bg-cyan-600 hover:bg-cyan-700 text-white" onClick={() => window.print()} data-testid="stock-label-print"><Printer className="w-4 h-4 mr-1" /> Print</Button>
      </div>
      <div className="p-4 print:p-0 flex flex-col items-center gap-4 print:gap-0">
        {items.map((it) => <div key={it.id} className="shadow print:shadow-none"><StockLabel item={it} width={width} /></div>)}
      </div>
    </div>
  );
}
